import React, { useEffect, useState } from 'react';
import TextInput from '../../../../Shared/TextInput/TextInput';

const OtpForm = (props) => {
  const [identityNumber, setIdentityNumber] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState({identityNumberError: '', phoneNumberError: ''});

  useEffect(() => {
    if (props.isSubmit) {
      let isValid = false;
      const isValidIdentityNumber = checkFieldValidation("identityNumber", identityNumber);
      const isValidPhoneNumber = checkFieldValidation("phoneNumber", phoneNumber);
      if (isValidIdentityNumber && isValidPhoneNumber) {
        isValid = true;
      }
      props.onValid({ isValid: isValid, form: {  identityNumber: identityNumber, phoneNumber: phoneNumber } });
    }
  }, [props.isSubmit]);


  const onChange = (type, value) => {
    checkFieldValidation(type, value)
  }

  const checkFieldValidation = (type, value) => {
    let isValid = true;
    switch (type) {
      case "phoneNumber":
        setPhoneNumber(value);
        if (!(/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(value))) {
          error.phoneNumberError = "אנא הכנס ערך תקין"
          setError({ ...error });
          isValid = false;
        }
        else {
          error.phoneNumberError = ""
          setError({ ...error });
        }
        break;
      case "identityNumber":
        setIdentityNumber(value);
        const isValidIdentityNumber =  validateIsraeliID(value);
        if (!isValidIdentityNumber) {
          error.identityNumberError = "אנא הכנס ערך תקין"
          setError({ ...error });
          isValid = false;
        }
        else {
          error.identityNumberError = ""
          setError({ ...error });
        }
      }
    return isValid;
  }

  const validateIsraeliID = (id) => {
    return (
      /\d{9}/.test(id) &&
      !id.match(/^0*$/) &&
      Array.from(id, Number).reduce((counter, digit, i) => {
        const step = digit * ((i % 2) + 1);
        return counter + (step > 9 ? step - 9 : step);
      }) % 10 === 0
    );
  };


  return (
    <div className='electric-company-lead-form-wrapper'>
      <div className='form-wrapper'>
        <TextInput
          onChange={(e) => onChange("phoneNumber", e.target.value)}
          value={phoneNumber}
          placeholder='טלפון'
          type='text'
          autoComplete='off'
          required='required'
          maxLength='10'
          error={error.phoneNumberError}
        />

        <TextInput
          onChange={(e) => onChange("identityNumber", e.target.value)}
          value={identityNumber}
          placeholder='תעודת זהות'
          type='text'
          autoComplete='off'
          required='required'
          error={error.identityNumberError}
        />

      </div>
      <p className="form-info-text">* יש למלא את פרטי בעל החוזה בחברת החשמל</p>
      <p className="form-info-text">{props.remarkText}</p>
    </div>
  );
};

export default OtpForm;
